export const enCommonLocale = {
  loading: 'Loading',
  recovering: 'Recovering...',
  recoveringDescription: "We're trying to restore your session. Please click the button below to reload the page.",
  reload: 'Reload',
  autoReloadMessage_one: 'The page will reload in {{seconds}} second.',
  autoReloadMessage_other: 'The page will reload in {{seconds}} seconds.',
  browserNotSupported: 'Your browser is not supported. Please use Google Chrome or another supported browser.',
};
